import { Link } from "gatsby"
import React, { useContext } from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { StaticImage } from "gatsby-plugin-image"

import styled from "styled-components"

import WebriQForm from "@webriq/gatsby-webriq-form"

const Banner = () => {
  return (
    <>
      <div className="hero-new-study">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mx-auto">
              <div className="title-banner">
                <h1 className="text-center">
                  Custom Quickbase App (Built in 6 Months) Turns Workday Into a
                  Mass Staffing Engine
                </h1>
                <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-sm-start text-center text-sm-left text-white">
                  <p className="pr-sm-1 mb-1 mb-sm-0">
                    <strong>Summary:</strong>
                  </p>
                  <p>
                    A global construction firm needed to staff high-risk job
                    sites fast, but manual Workday entry created delays and
                    compliance risks. Quandary built a custom app that lets
                    teams upload hundreds of verified records in minutes,
                    keeping projects on schedule and fully compliant.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 24px;
  padding: 24px 0;
`

const LogoCard = styled.div`
  background: #fff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  min-width: 160px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  padding: 12px;
`

const LogoImg = styled.img`
  max-width: 100%;
  max-height: 48px;
  object-fit: contain;
`

const Custom = ({ location }) => {
  return (
    <>
      <Layout banner={<Banner />} location={location}>
        <Seo
          title="Custom Quickbase App (Built in 6 Months) Turns Workday Into a Mass Staffing Engine"
          description="A construction firm had days to onboard hundreds of workers. We built a Quickbase app extending Workday to handle bulk uploads and verify credentials at scale."
        />
        <div className="py-4 py-md-5 case-studies-inner new-case-studies-inner bg-white">
          <div className="container">
            <div className="row">
              <div className="col-md-4 col-lg-4">
                <div
                  className="sidebar-tab relative results"
                  style={{ position: "sticky", top: "110px" }}
                >
                  <div className="relative results bg-case-study p-4">
                    <h3 className="mt-0 ">Results Snapshot</h3>
                    <ul className="ml-0">
                      <li>Onboarded 100+ employees in minutes</li>
                      <li>Eliminated manual HR entry</li>
                      <li>Reduced errors at scale</li>
                      <li>Extended Workday for high-volume staffing</li>
                      <li>Gained credential visibility across job sites</li>
                    </ul>
                  </div>
                  <a
                    className="btn btn-primary btn-arrow mr-2 mt-4 text-center relative w-full"
                    download
                    target="_blank"
                    href="https://cdn.sanity.io/files/55lcecww/production/ca6383a64fc97c44632bd2e7f48118fcece0ab9b.pdf"
                  >
                    Download This Story
                  </a>
                </div>
              </div>
              <div className="col-md-8 col-lg-8">
                <section className="relative">
                  <div className="relative px-0">
                    <div className="row mx-0">
                      <div className="col-md-11 mx-auto p-4 content-wrapper">
                        <div className="client-content">
                          <h2>The Challenge</h2>
                          <p>
                            With high-risk job sites going live across the
                            country, a global construction firm needed to
                            onboard hundreds of workers at once. But Workday
                            only allowed one record at a time, creating
                            bottlenecks that delayed staffing and put site
                            readiness at risk.
                          </p>
                          <p>
                            There was no scalable way to manage credentials,
                            certifications, or assignments in bulk. HR teams had
                            to re-enter the same information manually hundreds
                            of times. It was inefficient and increased the risk
                            of errors that could delay site openings or trigger
                            compliance violations.
                          </p>
                          <p>
                            The team needed a faster way to scale onboarding
                            without losing the structure, control, or
                            auditability that Workday was built to enforce.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper bg-grey">
                        <div className="client-content">
                          <h2>Our Solution</h2>
                          <p>
                            <Link to="/">Quandary Consulting Group</Link> built
                            a Mass Staffing Accelerator:{" "}
                            <Link to="/custom-quickbase-application-development/">
                              a custom Quickbase application
                            </Link>{" "}
                            that enables teams to upload hundreds of employee
                            records into Workday simultaneously, without
                            compromising compliance or accuracy.
                          </p>
                          <p>
                            The tool uses Workday’s API to automate high-volume
                            data entry and verification, eliminating the slow,
                            error-prone manual steps. It preserves all core
                            platform features while extending Workday’s ability
                            to support large-scale onboarding.
                          </p>
                          <p>
                            Each record is sent as a temporary entry and only
                            finalized after system-level validation. This gave
                            the team a fast, reliable path to scale staffing
                            while maintaining full control over compliance.
                          </p>

                          <p>
                            <strong>Key Features:</strong>
                          </p>
                          <ul className="pl-4">
                            <li>
                              <strong>Bulk Data Uploads: </strong>Onboards,
                              reassigns, or offboards hundreds of workers in one
                              step, eliminating manual entry.
                            </li>
                            <li>
                              <strong>Workday Extension: </strong>
                              Adds functionality for high-volume updates without
                              changing the core Workday setup.
                            </li>
                            <li>
                              <strong> Two-Way Sync: </strong>
                              Keeps credentials, job status, and access rights
                              aligned across Workday and local systems.
                            </li>
                            <li>
                              <strong> Compliance Checks at Scale: </strong>
                              Automatically flags missing certifications or
                              training gaps before they delay site access.
                            </li>
                            <li>
                              <strong> Reusable Staffing Data: </strong>
                              Stores credentials for future onboarding cycles to
                              avoid duplicate entry.
                            </li>
                            <li>
                              <strong> Site-Level Staffing Visibility: </strong>
                              Tracks staffing levels and credential readiness by
                              site in real time.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper">
                        <div className="client-content">
                          <h2>Our Process</h2>
                          <p>
                            This six-month build required,{" "}
                            <Link to="/faq/">
                              tight coordination between the client,
                            </Link>{" "}
                            Workday, and Quandary, working through complex
                            requirements and a rigid platform to design a
                            scalable solution from scratch.
                          </p>
                          <p>The process moved through five key phases:</p>
                          <p>
                            <strong>Key Steps:</strong>
                          </p>
                          <ol className="decimal">
                            <li>
                              <strong>Mapped onboarding requirements: </strong>{" "}
                              Broke down every data point needed per
                              employee—what was shared, what was unique, and how
                              it aligned with project staffing needs.
                            </li>
                            <li>
                              <strong>Designed a scalable workflow: </strong>{" "}
                              Built a workflow that could handle high-volume
                              inputs, staggered timelines, and evolving
                              credential rules.
                            </li>
                            <li>
                              <strong>
                                {" "}
                                Integrated with Workday’s infrastructure:{" "}
                              </strong>
                              Used the sandbox environment to test, adapt, and
                              validate API behavior with Workday’s team.
                            </li>
                            <li>
                              <strong>
                                {" "}
                                Built and iterated in Quickbase:{" "}
                              </strong>
                              Developed the app with rapid cycles of client
                              feedback, fixing issues surfaced only at scale.
                            </li>
                            <li>
                              <strong> Piloted and scaled the rollout: </strong>
                              Ran UAT in sandbox and live environments, launched
                              the app in two hiring centers, and scaled it
                              company-wide with structured training.
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper bg-gradient">
                        <div className="client-content">
                          <h2 className="text-white">The Roadblocks</h2>
                          <p className="text-white">
                            Mid-project, new edge cases broke the original
                            assumptions. Data logic had to be reworked.{" "}
                            <Link to="/quickbase-integration-services/">
                              API endpoints had to be extended.
                            </Link>{" "}
                            Requirements shifted.
                          </p>
                          <p className="text-white">
                            Instead of slowing down, the client, Workday, and
                            Quandary teams worked in lockstep, rebuilding
                            workflows, stress-testing integration points, and
                            keeping delivery on track.
                          </p>
                          <p className="text-white">
                            <Link to="/our-approach/">
                              Real-time feedback and rapid iteration
                            </Link>{" "}
                            ransformed a rigid system into one that effectively
                            met real-world needs without compromising compliance
                            or project timelines.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper">
                        <div className="client-content">
                          <h2>The Toolstack</h2>
                          <LogoGrid>
                            <LogoCard>
                              <LogoImg
                                src="https://cdn.sanity.io/images/55lcecww/production/78673169bfad856d32e060c5bf029890db184c60-261x101.png"
                                alt="Quickbase"
                              />
                            </LogoCard>
                          </LogoGrid>
                          <ul className="pl-4">
                            <li>
                              <strong>Quickbase: </strong>
                              Served as the foundation for the Mass Staffing
                              Accelerator, flexible enough to build fast, adapt
                              quickly, and handle messy, high-volume onboarding
                              data.
                            </li>
                            <li>
                              <strong> Workday Sandbox: </strong>
                              Enabled controlled API testing and live iteration
                              with Workday’s team so every update could be
                              validated without risking production.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto p-4 p-4 content-wrapper bg-blue">
                        <div className="client-content">
                          <h2 className="text-white">The Results</h2>
                          <p className="text-white">
                            The client can now onboard large teams in minutes
                            without delaying critical projects. HR can upload
                            hundreds of records at once, complete with verified
                            credentials and full visibility across all systems.
                          </p>
                          <p className="text-white">
                            Manual entry and duplication are significantly
                            reduced. Errors are down. Staffing is faster, and
                            compliance is stronger. All without changing core
                            Workday workflows.
                          </p>
                          <p className="text-white">
                            What used to delay high-risk projects is now a fast,
                            controlled process that keeps staffing on schedule
                            and compliant at scale.
                          </p>

                          <p>
                            <strong className="text-white">Key Results:</strong>
                          </p>
                          <ol className="decimal text-white">
                            <li className="text-white">
                              Onboarded 100+ workers in minutes
                            </li>
                            <li className="text-white">
                              Eliminated manual HR entry at scale
                            </li>
                            <li className="text-white">
                              Reduced errors across credential workflows
                            </li>
                            <li className="text-white">
                              Extended Workday for high-volume staffing without
                              disruption
                            </li>
                            <li className="text-white">
                              Gained real-time credential visibility by site
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div
                        className="col-md-11 mx-auto p-4 p-4 content-wrapper bg-grey"
                        style={{ marginTop: "30px" }}
                      >
                        <div className="client-content">
                          <h2>Client Overview:</h2>
                          <p>
                            A global construction firm operating across 360+
                            locations, managing thousands of workers across
                            complex job sites. The team is responsible for
                            ensuring that every worker on site is qualified,
                            credentialed, and compliant.
                          </p>
                          <div className="row align-items-center">
                            <div className="pl-4">
                              <p>
                                <strong>Industry:</strong> Commercial
                                Construction
                                <span className="relative d-block">
                                  <strong>Location:</strong> Global
                                </span>
                                <span className="relative d-block">
                                  <strong>Size:</strong> 360+ locations,
                                  thousands of employees
                                </span>
                              </p>
                            </div>

                            {/* <div className="col-md-6 pl-md-4 d-flex justify-content-center align-items-center border-left-md">
                              <LogoGrid>
                                <LogoCard>
                                  <LogoImg
                                    src="https://cdn.sanity.io/images/55lcecww/production/d4897c4eff3af5ae876b523c7a21bdfeffdd0e4c-1575x357.png"
                                    alt="Quickbase"
                                  />
                                </LogoCard>
                              </LogoGrid>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-11 mx-auto px-0 pt-4 content-wrapper">
                        <div className="client-content">
                          <div id="speak-with-specialist">
                            <div className="form-wrap-contact">
                              <div className="form-wrapper">
                                <div className="intro mb-2">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <h2 className="mt-0 font-weight-medium">
                                        Speak with Our Innovation Team
                                      </h2>
                                      <p>
                                        Use the form below to drop us an e-mail.
                                        We'll be in touch shortly.
                                      </p>
                                      <small className="text-red">
                                        Fields marked with an asterisk (*) are
                                        required.
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <WebriQForm
                                  id="contact-form"
                                  name="Contact Form"
                                  className="contactForm"
                                  data-form-id="4d46fe65-4d66-46b4-946c-e5826349ed3c"
                                  data-thankyou-url="/thank-you"
                                >
                                  <div className="row">
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                      {/* <p class="required">Full Name</p> */}

                                      <input
                                        type="text"
                                        name="Full Name"
                                        size={40}
                                        className="form-control required"
                                        placeholder="Full Name *"
                                        aria-label="Full Name"
                                        required
                                        id="requiredField"
                                      />
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mt-4 mt-lg-0">
                                      {/* <p class="required">Phone</p> */}
                                      <input
                                        type="text"
                                        name="Phone"
                                        size={40}
                                        // minLength={14}
                                        className="form-control required"
                                        id="phone"
                                        placeholder="Phone Number *"
                                        aria-label="Phone"
                                        required
                                      />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
                                      {/* <p class="required">Email</p> */}
                                      <input
                                        type="email"
                                        name="Email"
                                        size={40}
                                        className="form-control"
                                        aria-label="Email"
                                        placeholder="Email *"
                                        required
                                      />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
                                      {/* <p class="required">Message</p> */}
                                      <textarea
                                        name="Message"
                                        rows={5}
                                        cols={0}
                                        className="form-control"
                                        aria-label="Message"
                                        placeholder="Message *"
                                        required
                                      />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
                                      {/* <p class="required">How did you find out about us?</p> */}
                                      <div>
                                        <textarea
                                          type="text"
                                          name="How did you find out about us?"
                                          size={40}
                                          rows={5}
                                          className="form-control"
                                          aria-label="How did you find out about us?"
                                          placeholder="How did you find out about us? *"
                                          required
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mt-3">
                                    <div className="form-group col-12 d-flex justify-content-start captcha-wrap">
                                      <div className="webriq-recaptcha" />
                                    </div>
                                    <div className="form-group col-12 text-left">
                                      <div className="input-filled">
                                        <button
                                          type="submit"
                                          className="btn btn-primary btn-arrow"
                                        >
                                          SUBMIT
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </WebriQForm>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default Custom
